import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';

import { FormularioOrtodontia } from '../base/vo/formulario-ortodontia';
import { ItensTabelaPlanejamento } from '../base/util/itens-tabela-planejamento'

@Component({
    selector: 'app-tabela-planejamento',
    templateUrl: './tabela-planejamento.component.html',
    styleUrls: ['./tabela-planejamento.component.css']
})
export class TabelaPlanejamentoComponent implements OnInit {

    @Input() formularioOrtodontia: FormularioOrtodontia;
    @Input() apresentarDetalhe;
    @Input() apresentarAcao;

    @Output() removerItemEvent = new EventEmitter();

    public itensPlanejamento = [];

    constructor() { }

    ngOnInit() {
        this.atualizarTabela(this.formularioOrtodontia);
    }

    atualizarTabela(formularioOrtodontia){
        setTimeout(()=> this.itensPlanejamento = this.getItensVisiveis(formularioOrtodontia) )
    }

    private removerItem(indice, item){
        this.itensPlanejamento[indice].visivel = false;
        this.removerItemEvent.emit(item);
    }

    private getPlanejamento(item){
        if(!this.apresentarDetalhe){
            if(item.detalhe){
                return `${item.planejamento} - ${item.detalhe}`
            }
        }
        return item.planejamento;
    }

    private getItensVisiveis(formularioOrtodontia: FormularioOrtodontia){
        return ItensTabelaPlanejamento.getItensPlanejamento(formularioOrtodontia);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/tabela-planejamento/tabela-planejamento.component.ts